<template>
  <div id="app">
    <header class="header">
      <div class="container">
        <div class="row justify-content-between align-items-center">
          <div class="col-xs-2">
            <img src="dist/logo-pro-fesr-regione-veneto.png" alt="Logo FESR" class="img-fluid">
          </div>
          <div class="col-xs-2">
            <img src="dist/logo.svg" alt="Logo Walmec" class="img-fluid img-svg p-5">
          </div>
        </div>
      </div>
    </header>
    <div class="sub-header">
      <div class="container">
        <div class="row align-items-center pt-2">
          <div class="col">
            <h2>Un moltiplicatore di opportunità. Da non lasciarsi sfuggire.</h2>
          </div>
        </div>
      </div>
    </div>
    <article class="main-content p-5">
      <div class="container pt-5 pb-1">
        <div class="row">
          <div class="col">
            <h1 class="display-5 mb-5">Progetto di riqualificazione energetica - Walmec S.p.A.</h1>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <ul>
              <li>
                INSTALLAZIONE IMPIANTO FOTOVOLTAICO DA 374,4 kWp SENZA CONSUMO DI SUOLO
              </li>
              <li>
                INSTALLAZIONE DI UN SISTEMA TRIFASE TRASFORMAZIONE ELETTROMAGNETICA
              </li>
              <li>
                SOSTITUZIONE PRESSA STAMPAGGIO PLASTICA DA 200 T CON MACCHINA A RISPARMIO ENERGETICO
              </li>
            </ul>
            <p>
              Intervento realizzato avvalendosi del finanziamento
              POR - Obiettivo “Riduzione dei consumi energetici e delle emissioni
              nelle imprese e integrazione di fonti rinnovabili”
            </p>
            <p>
              Parte FESR fondo europeo di sviluppo regionale 2014-2020
            </p>
            <ul>
              <li>
                Asse: 4
              </li>
              <li>
                Azione: 4.2.1
              </li>
            </ul>
            <p class="small">Per ulteriori informazioni riguardo al <a href="//www.regione.veneto.it/web/programmi-comunitari/fesr-2014-2020">POR FESR Veneto 2014-2020</a> è possibile visitare il sito web dedicato all'indirizzo <a href="//www.regione.veneto.it/web/programmi-comunitari/fesr-2014-2020">www.regione.veneto.it/web/programmi-comunitari/fesr-2014-2020</a>. Per continuare a navigare sul sito <a href="//www.walmec.com">www.walmec.com</a>.</p>
          </div>
        </div>
      </div>
    </article>
    <footer class="footer">
      <div class="container">
        <span class="text-muted small">Copyright © 2018 Walmec S.p.A. - Via Trieste, 10 - 31025 Santa Lucia di Piave (TV) ITALY </span>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<style lang="scss">
  html {
    position: relative;
    min-height: 100%;
  }
  body {
    /* Margin bottom by footer height */
    margin-bottom: 60px;
    background-image: -webkit-linear-gradient(115deg, #f9b233 74%, #f39200 50%);
  }
  .header {
    .container {
      background: #fff;
      .img-svg {
        width: 100%;
        height: auto;
      }
    }
  }
  .sub-header {
    .container {
      background-color: #007d77;
      color: #fff;
    }
  }
  .main-content {
    .container {
      background-color: rgba(255, 255, 255, 0.7);

    }
  }
  .footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    /* Set the fixed height of the footer here */
    height: 60px;
    line-height: 60px; /* Vertically center the text there */
    background-color: #f5f5f5;
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }

  h1, h2 {
    font-weight: normal;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue